module.exports = __webpack_public_path__ + "static/img/cabinate.494e964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabinate.png
// module id = bKie
// module chunks = 0